<template>
  <Head title="Privacybeleid">
    <meta
      name="description"
      content="Zo gaan wij om met gegevens."
    >
    <link
      rel="canonical"
      :href="localeRoute('frontend.privacy-statement')"
    >
    <meta
      property="og:image"
      content="/frontend/assets/favicon/og-image.jpg"
    >
  </Head>

  <section class="content-hero py-20 relative overflow-hidden">
    <img
      class="absolute top-0 left-0 lg:hidden"
      src="/frontend/assets/mobile-hero-swirl.svg"
    >
    <img
      class="absolute top-0 left-0 hidden lg:block"
      src="/frontend/assets/desktop-hero-swirl.svg"
    >

    <div class="container">
      <div class="text-center px-8">
        <h1 class="text-5xl font-bold lg:text-7xl">
          Privacy Statement
        </h1>
      </div>
    </div>
  </section>

  <section class="content text-lg py-20 relative bg-white">
    <img
      class="hidden lg:block absolute left-0 top-[400px]"
      src="/frontend/assets/scribble-round-desktop.svg"
    >

    <div class="container">
      <h2 class="font-bold pb-2">
        A. Inleiding
      </h2>
      <p>
        Dit is het Privacy-en Cookie Statement van ShoutOut VIP B.V. (gevestigd aan de Wingerdweg 229, 1032 AH in
        Amsterdam,
        ingeschreven bij de Kamer van Koophandel onder registratienummer 78153034) (hierna: “wij”, “ons” of
        “ShoutOut.vip”).
        ShoutOut.vip is de verantwoordelijke voor de verwerking van persoonsgegevens zoals beschreven in dit Privacy-en
        Cookie
        Statement. Onze contactgegevens staan onderaan dit Statement vermeld.
      </p>
      <p>
        In dit Privacy-en Cookie Statement (hierna ‘Statement’ genoemd) informeren we je over de gegevens die we
        verwerken
        van bezoekers en gebruikers van onze website. Dit Statement is van toepassing op alle persoonsgegevens die wij
        verwerken. “Persoonsgegevens” zijn alle gegevens die herleidbaar zijn tot jou als individu, zoals
        contactgegevens, maar
        ook andere gegevens die uniek zijn voor jou, zoals je bestelgeschiedenis of surfgedrag. Daarnaast bevat dit
        Statement
        informatie over het gebruik van cookies.
      </p>
      <p>
        We kunnen dit Statement van tijd tot tijd herzien. Het is daarom raadzaam om dit Statement regelmatig te
        checken,
        zodat je altijd volledig op de hoogte bent van ons privacy beleid. In ons Statement wordt altijd de laatste
        datum van
        wijziging aangegeven. Dit Statement is voor het laatst herzien op 25 april 2022.
        Lees ook onze algemene voorwaarden, die van toepassing zijn op het gebruik van onze website en het afnemen van
        onze
        diensten.
      </p>
      <h2 class="font-bold pb-2">
        B. Welke gegevens verwerken wij en waarvoor gebruiken we die?
      </h2>
      <h3 class="font-bold pb-2 italic">
        1. Gegevens voor het plaatsen van een aanvraag voor een ShoutOut
      </h3>
      <p>
        Als je een aanvraag plaatst voor een ShoutOut vragen we je om je naam, e-mailadres, je telefoonnummer en de naam
        van
        de ontvanger te verstrekken. Deze gegevens hebben we nodig om de overeenkomst uit te voeren die je met ons hebt
        gesloten en de link naar jouw ShoutOut aan je toe te sturen.
      </p>
      <p>
        Als je een ShoutOut bestelt, kunnen wij jouw voornaam, de naam van de ontvanger en de ShoutOut openbaar maken
        via
        onze website en onze social mediakanalen voor promotionele doeleinden. Als je niet wil dat jouw ShoutOut voor
        promotionele doeleinden wordt gebruikt, dan kun je dat bij jouw aanvraag aangeven door een vinkje te zetten bij:
        “Deze
        video niet publiek delen op ShoutOut.vip”.
      </p>
      <h3 class="font-bold pb-2 italic">
        2. Gegevens van de ontvanger van een ShoutOut
      </h3>
      <p>
        Wanneer iemand een ShoutOut voor jou bestelt, krijgen we van diegene jouw naam. Deze gegevens zijn nodig om de
        ShoutOut te maken.
      </p>
      <h3 class="font-bold pb-2 italic">
        3. Gegevens over jouw contact met onze klantenservice
      </h3>
      <p>
        Via <a
          class="text-blue underline"
          href="mailto:hi@shoutout.vip"
        >hi@shoutout.vip</a> kan je bij ons terecht voor vragen. Je kan ook een berichtje sturen via social media, zoals
        Instagram
        of Facebook. De gegevens die je op deze manier met ons deelt gebruiken we om met jou contact op te nemen naar
        aanleiding van jouw vraag. Ook gebruiken we deze gegevens voor het verbeteren van onze dienstverlening.
      </p>
      <h3 class="font-bold pb-2 italic">
        4. Gegevens bij deelname aan wedstrijden of promotionele acties
      </h3>
      <p>
        Zo nu en dan organiseren we een wedstrijd of een promotionele actie. Als je daaraan meedoet, dan verzamelen we
        jouw
        gegevens. Deze gegevens hebben we nodig om de wedstrijd of actie te kunnen uitvoeren en de prijswinnaar(s)
        bekend te
        maken. Als je daarmee akkoord gaat, kunnen we de gegevens die je met ons deelt bij de wedstrijd of de actie ook
        voor
        andere doeleinden gebruiken, zoals voor marketingdoeleinden gebruiken. In de actievoorwaarden die gelden voor de
        desbetreffende wedstrijd of actie kan je hier meer informatie over vinden.
      </p>
      <h3 class="font-bold pb-2 italic">
        5. Gegevens voor marketingdoeleinden
      </h3>
      <p>
        Als je ons daarvoor toestemming hebt gegeven, dan e-mailen we je over het laatste nieuws van ShoutOut.vip. Als
        je geen
        e-mails van ons wil ontvangen, dan kan je je hiervoor afmelden via de link onderaan onze e-mails.
      </p>
      <h3 class="font-bold pb-2 italic">
        6. Sollicitaties
      </h3>
      <p>
        Je kan op onze website solliciteren via een site die wordt beheerd door derden (o.a. via de link “Vacatures” op
        onze
        website) of rechtstreeks bij ons. Voor sollicitaties via derden geldt het privacybeleid van deze derde partij.
        We raden je
        aan dit privacybeleid te lezen voordat je persoonsgegevens verstrekt, omdat dit beleid kan verschillen van ons
        Statement.
        Gegevens die je met ons deelt in verband met jouw sollicitatie zullen we alleen gebruiken in verband met jouw
        sollicitatie.
      </p>
      <h3 class="font-bold pb-2 italic">
        7. Gegevens voor feedback en reviews
      </h3>
      <p>
        Als je feedback, reviews, foto’s, filmpjes en dergelijke met ons deelt, bijvoorbeeld via onze website of via
        onze social
        mediakanalen, over jouw ShoutOut, de reactie van de ontvanger op jouw ShoutOut of jouw ervaring met het gebruik
        van
        onze website kunnen wij dit openbaar maken via onze website en onze social mediakanalen voor promotionele
        doeleinden. Als we daarbij ook jouw persoonsgegevens openbaar maken, zullen we hiervoor altijd jouw toestemming
        vragen.
      </p>
      <h3 class="font-bold pb-2 italic">
        8. Analyseren van gegevens
      </h3>
      <p>
        Wij analyseren informatie uit klik-en koopgedrag op onze website, feedback, marktonderzoek en andere bronnen om
        inzicht te krijgen in de bezoekers van onze website en om onze diensten te verbeteren. We zorgen ervoor dat deze
        analyses alleen op geaggregeerd niveau worden gerapporteerd. Hierdoor zijn resultaten niet tot individuen te
        herleiden.
        Het uitvoeren van analyses doen ij vanuit ons gerechtvaardigd belang.
      </p>
      <h2 class="font-bold pb-2">
        C. Met wie delen we jouw gegevens?
      </h2>
      <h3 class="font-bold pb-2 italic">
        1. Externe dienstverleners
      </h3>
      <p>
        Zo nu en dan schakelen wij externe dienstverleners in die ons ondersteunen bij verschillende zaken. Soms hebben
        zij daar
        persoonsgegevens voor nodig of hebben ze daar toegang toe. Natuurlijk delen wij alleen gegevens die de
        dienstverlener
        nodig heeft voor de uitvoering van de opdracht door de dienstverlener. Verder zorgen we ervoor dat met deze
        dienstverleners een overeenkomst wordt gesloten waarin is vastgelegd wat ze met de gegevens mogen doen. Het kan
        gaan om de voldoende werkzaamheden:
      </p>
      <ul class="list-disc pb-2 ml-6">
        <li>Technische ondersteuning van onze website en onze app, zoals hosting en onderhoud;</li>
        <li>Het ondersteunen bij marketingactiviteiten;</li>
        <li>Het ondersteunen bij het doen van analyses om onze dienstverlening te verbeteren.</li>
      </ul>
      <h3 class="font-bold pb-2 italic">
        2. Overheid
      </h3>
      <p>
        Het kan zijn dat wij door overheidsinstanties worden verplicht om bepaalde persoonsgegevens te verstrekken.
        Uiteraard
        zullen wij daaraan onze medewerking verlenen, binnen de wettelijke grenzen.
      </p>
      <h2 class="font-bold pb-2">
        D. Doorgifte van persoonsgegevens naar derde landen
      </h2>
      <p>
        We slaan jouw persoonsgegevens op binnen de Europese Economische Ruimte (EER). Het kan voorkomen dat bepaalde
        persoonsgegevens worden doorgegeven of opgeslagen buiten de EER, bijvoorbeeld omdat een dienstverlener van
        ShoutOut.vip daar gevestigd is. Je kan ervan uitgaan, dat we ervoor zorgen dat dit op een veilige manier gebeurt
        en
        voldoet aan de wet-en regelgeving.
      </p>
      <h2 class="font-bold pb-2">
        E. Hoe beveiligen we jouw gegevens?
      </h2>
      <p>
        We hebben de nodige beveiligingsmaatregelen genomen om jouw persoonsgegevens te beschermen. Zowel op
        organisatorisch als technisch gebied. Deze maatregelen bestaan onder meer uit:
      </p>
      <ul class="list-disc pb-2 ml-6">
        <li>logische toegangscontrole op onze laptops en systemen, gebruik makend van wachtwoorden;</li>
        <li>Databases zijn enkel intern te bereiken</li>
        <li>Onze website werkt enkel via een beveiligde verbinding</li>
      </ul>

      <p>
        Mocht je meer informatie willen hebben, dan kan je contact met ons opnemen via onze contactgegevens onderaan
        het
        document.
      </p>
      <h2 class="font-bold pb-2">
        F. Hoe lang bewaren we jouw gegevens?
      </h2>
      <p>
        We zullen jouw persoonsgegevens niet langer bewaren of gebruiken dan nodig is (i) voor de doeleinden die in dit
        Statement zijn vermeld en (ii) om te kunnen voldoen aan wettelijke verplichtingen die op ons rusten.
      </p>
      <h2 class="font-bold pb-2">
        G. Kinderen
      </h2>
      <p>
        Onze diensten en onze website zijn niet speciaal gericht op kinderen. We verzamelen niet bewust
        persoonsgegevens van
        kinderen zonder toestemming van een ouder of wettelijke vertegenwoordiger. Mochten we ontdekken dat we dit
        onverhoopt hebben gedaan, dan zullen we deze gegevens direct verwijderen. Als je een ouder of wettelijke
        vertegenwoordiger bent en gelooft dat we persoonsgegevens van jouw kind hebben verzameld of gebruikt, dan vragen
        we je contact met ons op te nemen via onze contactgegevens onderaan het document.
      </p>
      <h2 class="font-bold pb-2">
        H. Social media
      </h2>
      <p>
        Net als iedereen zijn we dol op social media. Op onze website maken we gebruik van social media buttons. Als je
        daarop
        klikt, word je doorgeleid naar het social media platform. Daarnaast kan je via de social mediakanalen met ons
        communiceren. Als je wil weten wat de social media platforms doen met jouw gegevens, dan kan je dat nalezen de
        privacyverklaring van de social media platforms.
      </p>
      <h2 class="font-bold pb-2">
        I. Cookies
      </h2>
      <p>
        Wij maken gebruik van cookies om informatie te verzamelen over het gebruik van onze website en onze app.
        Cookies zijn
        kleine bestandjes die een website op jouw device (zoals je computer, tablet of smartphone) achterlaat. Dat
        gebeurt via de
        webbrowser of je device. Wij en derde partijen gebruiken cookies om:
      </p>
      <ul class="list-disc pb-2 ml-6">
        <li>functionaliteiten van onze website mogelijk te maken (technische en functionele cookies);</li>
        <li>
          het gebruik van de website te analyseren om onze website gebruiksvriendelijker te maken en de gebruikers
          van onze website beter te begrijpen (analytische cookies);
        </li>
      </ul>
      <p>Deze cookies verzamelen de volgende gegevens van jou:</p>
      <ul class="list-disc pb-2 ml-6">
        <li>IP-adres</li>
        <li>Cookie-ID</li>
        <li>Applicatie-en klikgedrag</li>
      </ul>
      <p>
        Als je onze website voor het eerst bezoekt, zie je een melding met uitleg over cookies. Voor zover we daartoe
        verplicht
        zijn, vragen we hierin ook om jouw akkoord voor het gebruik van cookies.
        Hieronder vind je een overzicht van de cookies die we gebruiken:
      </p>

      <table class="border-collapse border table-auto pb-2">
        <tbody>
          <tr>
            <th class="border text-left p-1">
              Name
            </th>
            <th class="border text-left p-1">
              Domain
            </th>
          </tr>
          <tr>
            <td class="border p-1">
              APISID
            </td>
            <td class="border p-1">
              .google.nl
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              HSID
            </td>
            <td class="border p-1">
              .google.nl
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              __Secure-3PSID
            </td>
            <td class="border p-1">
              .google.nl
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              __Secure-1PSID
            </td>
            <td class="border p-1">
              .google.nl
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              __Secure-1PAPISID
            </td>
            <td class="border p-1">
              .google.nl
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              __Secure-3PSIDCC
            </td>
            <td class="border p-1">
              .google.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              SAPISID
            </td>
            <td class="border p-1">
              .google.nl
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              __Secure-1PSIDCC
            </td>
            <td class="border p-1">
              .google.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              __Secure-3PAPISID
            </td>
            <td class="border p-1">
              .google.nl
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              SSID
            </td>
            <td class="border p-1">
              .google.nl
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              __Secure-3PAPISID
            </td>
            <td class="border p-1">
              .google.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              APISID
            </td>
            <td class="border p-1">
              .google.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              SSID
            </td>
            <td class="border p-1">
              .google.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              __Secure-1PAPISID
            </td>
            <td class="border p-1">
              .google.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              __Secure-1PSID
            </td>
            <td class="border p-1">
              .google.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              SAPISID
            </td>
            <td class="border p-1">
              .google.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              SIDCC
            </td>
            <td class="border p-1">
              .google.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              SID
            </td>
            <td class="border p-1">
              .google.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              MUID
            </td>
            <td class="border p-1">
              .clarity.ms
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              HSID
            </td>
            <td class="border p-1">
              .google.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              __Secure-3PSID
            </td>
            <td class="border p-1">
              .google.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              SID
            </td>
            <td class="border p-1">
              .google.nl
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              __Secure-ENID
            </td>
            <td class="border p-1">
              .google.nl
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              UULE
            </td>
            <td class="border p-1">
              www.google.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              DV
            </td>
            <td class="border p-1">
              www.google.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              1P_JAR
            </td>
            <td class="border p-1">
              .google.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              lms_analytics
            </td>
            <td class="border p-1">
              .linkedin.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              NID
            </td>
            <td class="border p-1">
              .google.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              OTZ
            </td>
            <td class="border p-1">
              www.google.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              lang
            </td>
            <td class="border p-1">
              .linkedin.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              liap
            </td>
            <td class="border p-1">
              .linkedin.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              aam_uuid
            </td>
            <td class="border p-1">
              .linkedin.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              lidc
            </td>
            <td class="border p-1">
              .linkedin.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              AEC
            </td>
            <td class="border p-1">
              .google.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              lang
            </td>
            <td class="border p-1">
              .ads.linkedin.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              AMCV_14215E3D5995C57C0A495C55%40AdobeOrg
            </td>
            <td class="border p-1">
              .linkedin.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              AMCVS_14215E3D5995C57C0A495C55%40AdobeOrg
            </td>
            <td class="border p-1">
              .linkedin.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              lms_ads
            </td>
            <td class="border p-1">
              .linkedin.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              AnalyticsSyncHistory
            </td>
            <td class="border p-1">
              .linkedin.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              __Secure-ENID
            </td>
            <td class="border p-1">
              .google.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              _fbp
            </td>
            <td class="border p-1">
              .shoutout.vip
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              bcookie
            </td>
            <td class="border p-1">
              .linkedin.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              CLID
            </td>
            <td class="border p-1">
              www.clarity.ms
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              SOCS
            </td>
            <td class="border p-1">
              .google.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              li_mc
            </td>
            <td class="border p-1">
              .linkedin.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              shoutoutvip_session
            </td>
            <td class="border p-1">
              shoutout.vip
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              _clck
            </td>
            <td class="border p-1">
              .shoutout.vip
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              li_gc
            </td>
            <td class="border p-1">
              .linkedin.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              UserMatchHistory
            </td>
            <td class="border p-1">
              .linkedin.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              NID
            </td>
            <td class="border p-1">
              .google.nl
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              _gat_UA-112824527-4
            </td>
            <td class="border p-1">
              .shoutout.vip
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              purTDvLyECGlL86q59KV3vRKoAreZxsETliktpKz
            </td>
            <td class="border p-1">
              shoutout.vip
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              _gid
            </td>
            <td class="border p-1">
              .shoutout.vip
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              _ga
            </td>
            <td class="border p-1">
              .shoutout.vip
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              country
            </td>
            <td class="border p-1">
              shoutout.vip
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              _hjAbsoluteSessionInProgress
            </td>
            <td class="border p-1">
              .shoutout.vip
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              _clsk
            </td>
            <td class="border p-1">
              .shoutout.vip
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              ln_or
            </td>
            <td class="border p-1">
              shoutout.vip
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              _hjSession_1938394
            </td>
            <td class="border p-1">
              .shoutout.vip
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              _gcl_au
            </td>
            <td class="border p-1">
              .shoutout.vip
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              _hjSessionUser_1938394
            </td>
            <td class="border p-1">
              .shoutout.vip
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              _gaexp
            </td>
            <td class="border p-1">
              .shoutout.vip
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              _guid
            </td>
            <td class="border p-1">
              .linkedin.com
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              _tdid
            </td>
            <td class="border p-1">
              .shoutout.vip
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              _tdbu
            </td>
            <td class="border p-1">
              .shoutout.vip
            </td>
          </tr>
          <tr>
            <td class="border p-1">
              _hjIncludedInSessionSample
            </td>
            <td class="border p-1">
              shoutout.vip
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        Je kan ervoor kiezen om geen toestemming te geven aan het plaatsen van cookies, of cookies uit te schakelen via
        je
        browser. Dat kan effect hebben op de gebruiksmogelijkheden van onze website en onze app.
      </p>
      <h2 class="font-bold pb-2">
        J. Jouw wettelijke rechten
      </h2>
      <p>
        Je kan op elk moment bij ons opvragen welke persoonsgegevens wij van jou verwerken. Je kan daarbij ook uw
        gegevens
        laten verwijderen, beperken, aanpassen of aanvullen. Als je van deze mogelijkheid gebruik wil maken, stuur dan
        een email naar <a
          class="text-blue underline"
          href="mailto:hi@shoutout.vip"
        >hi@shoutout.vip</a>. Wij zullen dan binnen 4 weken op je verzoek reageren. Overigens kan het
        verwijderen van je
        gegevens gevolgen hebben voor het gebruik van onze website en onze diensten.
      </p>
      <p>
        Je hebt het recht om een klacht in te dienen over de wijze waarop wij met jouw persoonsgegevens omgaan.
        Natuurlijk
        lossen we dit het liefste op een goede manier met je op. Je kan hiervoor een e-mail sturen via <a
          class="text-blue underline"
          href="mailto:hi@shoutout.vip"
        >hi@shoutout.vip</a>.
        Je hebt
        ook het recht om je met je klacht te wenden tot de Autoriteit Persoonsgegevens.
      </p>
      <h2 class="font-bold pb-2">
        K. Contact
      </h2>
      <p>
        Als je verder nog vragen of opmerkingen hebt, horen we graag van via e-mail (hi@ShoutOut.vip). We zullen zo snel
        mogelijk reageren op jouw e-mail.
      </p>
    </div>
  </section>
</template>
